import { v4 as uuidv4 } from "uuid";
import { IThuPhiNhapHocTab } from "../../../model/request/thu-phi-nhap-hoc/IThuPhiNhapHocTab";
import { IThuPhiNhapHocActionTypes } from "../../action-types/thu-phi-nhap-hoc/IThuPhiNhapHocActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IThuPhiNhapHocReducer } from "../../reducer-model/thu-phi-nhap-hoc/IThuPhiNhapHocReducer";
import { IMucThuNhapHocSinhVienViewModel } from "../../../model/respone/chung-tu-nhap-hoc/IMucThuNhapHocSinhVienViewModel";
const iniTab: IThuPhiNhapHocTab = {
  id: uuidv4(),
  title: "Untitled",
  mucThuNhapHocs: [],
  mucThuNhapHocSelectedIds: [],
  step: 0,
  namNhapHoc: 0,
  hinhThucNops: [],
  status: eReducerStatusBase.is_not_initialization,
  thongTinBienLai: {
    bienLaiId: 0,
    bienLaiPhieuThu: "",
    bienLaiTempPhieuThu: "",
    loaiBienLai: "thu",
    chiTuBienLaiId: 0,
  },
};
const iniState: IThuPhiNhapHocReducer = {
  selectedId: iniTab.id,
  tabs: [iniTab],
};
export const thuPhiNhapHocReducer = (
  state: IThuPhiNhapHocReducer = iniState,
  action: IThuPhiNhapHocActionTypes
): IThuPhiNhapHocReducer => {
  switch (action.type) {
    case "THU_PHI_NHAP_HOC_ADD_NEW_TAB":
      let exist = state.tabs.find(
        (g) =>
          g.sinhVien?.id_sv === action.payload?.id_sv &&
          g.thongTinBienLai.bienLaiId <= 0
      );
      const id = exist?.id ?? uuidv4();
      return {
        ...state,
        selectedId: id,
        tabs: exist
          ? [...state.tabs]
          : [
              {
                ...iniTab,
                title: action.payload?.ho_ten ?? "Untitled",
                id: id,
                sinhVien: action.payload,
              },
              ...state.tabs,
            ],
      };
    case "THU_PHI_NHAP_HOC_REMOVE_TAB":
      return {
        ...state,
        tabs: state.tabs.filter((t) => t.id !== action.payload),
      };
    case "THU_PHI_NHAP_HOC_UPDATE_TAB_DATA":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.id) {
            return action.payload;
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_CHANGEG_SELECTED_TAB":
      return {
        ...state,
        selectedId: action.payload,
      };
    case "THU_PHI_NHAP_HOC_LOAD_MUC_THU_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.id_sv) {
            return {
              ...t,
              namNhapHoc: action.payload.nam_nhap_hoc,
              status: eReducerStatusBase.is_loading,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_LOAD_MUC_THU_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              mucThuNhapHocs: action.payload.data,
              mucThuNhapHocSelectedIds: [],
              hinhThucNops: [],
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_LOAD_MUC_THU_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              mucThuNhapHocs: [],
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_CHANGE_MUC_THU_SELECTED_IDs":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            let muc_thu_selected_id_news = action.payload.data.filter(
              (item) => !t.mucThuNhapHocSelectedIds.includes(item)
            );
            return {
              ...t,
              hinhThucNops: [],
              mucThuNhapHocSelectedIds: action.payload.data,
              mucThuNhapHocs: t.mucThuNhapHocs.map((g) => {
                if (action.payload.data.includes(g.id_thu_chi)) {
                  if (muc_thu_selected_id_news?.includes(g.id_thu_chi)) {
                    return {
                      ...g,
                      so_tien_thuc_nop: Math.abs(g.so_tien_con_lai),
                    };
                  }
                  return g;
                }
                return {
                  ...g,
                  so_tien_thuc_nop: 0,
                };
              }),
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_CHANGE_STEP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              step: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_CHANGE_HINHTHUCNOP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              hinhThucNops: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_CREATE_BIENLAITHU_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_saving,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_CREATE_BIENLAITHU_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_need_reload,
              //status: eReducerStatusBase.is_completed,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiId: action.payload.data,
              },
              step: 2,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_CREATE_BIENLAITHU_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              bienLaiId: 0,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_CHANGE_SO_TIEN_THUC_NOP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              hinhThucNops: [],
              mucThuNhapHocSelectedIds: [
                ...t.mucThuNhapHocSelectedIds.filter(
                  (g) => g !== (action.payload.request?.id_thu_chi ?? 0)
                ),
                action.payload.data > 0
                  ? action.payload.request?.id_thu_chi ?? 0
                  : 0,
              ],
              mucThuNhapHocs: [
                ...t.mucThuNhapHocs.map(
                  (mtk: IMucThuNhapHocSinhVienViewModel) => {
                    if (mtk.id_thu_chi === action.payload.request.id_thu_chi) {
                      return {
                        ...mtk,
                        so_tien_thuc_nop: action.payload.data,
                      };
                    }
                    return mtk;
                  }
                ),
              ],
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_CHANGE_THONGTINBIENLAI":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            let obj = {
              ...t,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                ...action.payload.data,
              },
            };
            if ("loaiBienLai" in action.payload.data) {
              obj = {
                ...obj,
                mucThuNhapHocs: [],
                mucThuNhapHocSelectedIds: [],
                hinhThucNops: [],
                step: 0,
                status: eReducerStatusBase.is_need_reload,
              };
            }
            return obj;
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_PREVIEW_BIENLAITHU_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiTempPhieuThu: action.payload.data,
              },
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_PREVIEW_BIENLAITHU_CLOSE":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiTempPhieuThu: "",
              },
            };
          }
          return t;
        }),
      };
    case "THU_PHI_NHAP_HOC_UPDATE_QRCODE":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.id) {
            return {
              ...t,
              qrCode: action.payload.data,
            };
          }
          return t;
        }),
      };
    default:
      return state;
  }
};
